// src/services/AuthService.js

async function loginUser(username, password) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/loginPolice`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, password })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data; 
  } catch (error) {
    console.error('Login failed');
    throw error;
  }
}

async function logoutUser(token) {
  const url = `${process.env.REACT_APP_API_URL}/Auth/logout`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Logout failed');
    throw error;
  }
}

export default { loginUser, logoutUser };
